export class ShipmentTransportOrderTrackingMapLoad {
  public static readonly type = '[ShipmentTransportOrderTrackingMap] Load';
  constructor(public payload: number) {}
}

export class ShipmentTransportOrderTrackingMapInitialState {
  public static readonly type = '[ShipmentTransportOrderTrackingMap] Set Initial State';
}
